(function () {
  'use strict';

  var modal, modalContent, backdrop, modalBox;
  var panel, panelClose, panelImage, panelSelect, panelAdd, panelConfirm;
  var currentMiniData = null;
  var currentMiniVariantId = null;

  var MINI_ADD_BUTTON_TEXT = 'Add Mini Stickers';
  var CHROME_TRANSITION_MS = 380;

  var MINI_OPTION_NAMES = ['MINI PACK', 'ADD MATCHING 1 INCH STICKERS? (OPTIONAL)'];
  var MINI_NONE_VALUES = ['Main Design', 'No Add-Ons Please!'];
  var HIDDEN_PLACEHOLDER_VALUE = '1x1';
  var MAGNET_PREFIX = 'Magnet - ';

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Decodes the base64-encoded cross-collection discovery HTML block that
     sections/full-catalog-page.liquid, snippets/catalog-menu-preview.liquid,
     and snippets/product-card.liquid all now render into each clickable
     card's data-discovery-html attribute (see snippets/product-discovery-links.liquid
     for what it contains — "Also found in" + "Try our other collections" +
     the CLOSE link). Needed because this modal's product data comes from the
     /products/{handle}.js JSON endpoint, which has no collections field, so
     the discovery HTML has to be pre-rendered server-side (where the real
     `product` object is in scope) and carried through as a data attribute
     instead of being derivable client-side after the fetch. Returns '' on
     any decode failure so callers can cleanly fall back to the old
     single-link behavior. */
  function decodeDiscoveryHtml(encoded) {
    if (!encoded) return '';
    try {
      var binary = atob(encoded);
      var bytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return new TextDecoder('utf-8').decode(bytes);
    } catch (e) {
      return '';
    }
  }

  /* Collects the same cart-drawer/cart-icon section IDs the theme's native
     product form requests on every add, so this custom quick-view popup's
     Add to Cart requests feed the theme's real cart-icon/cart-drawer
     refresh mechanism instead of a set of Dawn-era event names/selectors
     ('cart:refresh', 'cart:updated', 'cart-notification:open', '.cart-count'
     etc.) that don't exist anywhere in this theme and were silent no-ops. */
  function getCartSectionIds() {
    return Array.prototype.map
      .call(document.querySelectorAll('cart-items-component'), function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean);
  }

  /* Dispatches the theme's real cart:update event (see assets/events.js —
     ThemeEvents.cartUpdate) with the fields cart-icon.js and
     component-cart-items.js actually read: data.itemCount for the header
     badge, data.sections for the drawer/line-item re-render. */
  function dispatchCartUpdate(cart, sections, sourceId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: sourceId,
        data: { source: 'full-catalog-page', itemCount: cart.item_count, sections: sections }
      }
    }));
  }

  window.fcpOpen = function (handle, collectionHandle, collectionTitle, discoveryHtml) {
    if (!modal) { setup(); }
    closeUpsellPanel();
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    modalContent.innerHTML = '<div class="fcp-modal__loading">Loading&hellip;</div>';
    document.body.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { renderModal(product, collectionHandle, collectionTitle, discoveryHtml); })
      .catch(function () {
        modalContent.innerHTML =
          '<p style="padding:2.5rem;text-align:center;color:#b00">Could not load product. ' +
          '<a href="/products/' + handle + '" style="color:#522060">View product page &rarr;</a></p>';
      });
  };

  window.fcpClose = function () {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    closeUpsellPanel();
  };

  function getSrc(img) {
    if (!img) return '';
    return typeof img === 'string' ? img : (img.src || '');
  }

  function imgUrl(img, w) {
    var src = getSrc(img);
    if (!src) return '';
    try {
      var clean = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+)(\.[a-z]+)/i, '$2');
      var sep = clean.indexOf('?') === -1 ? '?' : '&';
      return clean + sep + 'width=' + w;
    } catch (e) { return src; }
  }

  function money(cents) {
    return (typeof Shopify !== 'undefined' && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function getMiniPackData(product) {
    var options = product.options || [];
    var indices = [];
    for (var i = 0; i < options.length; i++) {
      if (MINI_OPTION_NAMES.indexOf(options[i].name) !== -1) indices.push(i);
    }
    if (!indices.length) return null;

    var activeIndex = -1;
    for (var k = 0; k < indices.length; k++) {
      if (options[indices[k]].name === 'MINI PACK') { activeIndex = indices[k]; break; }
    }
    if (activeIndex === -1) activeIndex = indices[0];

    var items = (product.variants || []).filter(function (v) {
      return v.options[activeIndex] && MINI_NONE_VALUES.indexOf(v.options[activeIndex]) === -1;
    }).map(function (v) {
      return { id: v.id, label: v.options[activeIndex], price: v.price, available: v.available };
    });
    if (!items.length) return null;
    return { indices: indices, index: activeIndex, items: items };
  }

  function findMaterialOptionIndex(options, miniIndices) {
    miniIndices = miniIndices || [];
    for (var i = 0; i < options.length; i++) {
      if (miniIndices.indexOf(i) !== -1) continue;
      var vals = options[i].values || [];
      for (var j = 0; j < vals.length; j++) {
        if (typeof vals[j] === 'string' && vals[j].indexOf(MAGNET_PREFIX) === 0) return i;
      }
    }
    return -1;
  }

  function getHandleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function hasGalleryImageClass(el) {
    if (!el.classList) return false;
    for (var i = 0; i < el.classList.length; i++) {
      var c = el.classList[i];
      if (c.indexOf('gallery-all-image-') === 0 || c.indexOf('gallery-main-image-') === 0) return true;
    }
    return false;
  }

  function setup() {
    modal        = document.getElementById('fcp-modal');
    if (!modal) return;
    modalContent = modal.querySelector('.fcp-modal__content');
    backdrop     = modal.querySelector('.fcp-modal__backdrop');
    modalBox     = modal.querySelector('.fcp-modal__box');
    panel        = document.getElementById('fcp-upsell-panel');
    panelClose   = document.getElementById('fcp-upsell-close');
    panelImage   = document.getElementById('fcp-upsell-image');
    panelSelect  = document.getElementById('fcp-upsell-select');
    panelAdd     = document.getElementById('fcp-upsell-add');
    panelConfirm = document.getElementById('fcp-upsell-confirm');

    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) window.fcpClose(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) window.fcpClose();
    });

    if (panelClose) {
      panelClose.addEventListener('click', function () { closeUpsellPanel(); });
    }

    if (panelSelect) {
      panelSelect.addEventListener('change', function () {
        currentMiniVariantId = parseInt(panelSelect.value, 10);
      });
    }

    if (panelAdd) {
      panelAdd.addEventListener('click', function () {
        if (!currentMiniVariantId) return;
        panelAdd.disabled = true;
        panelAdd.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: currentMiniVariantId, quantity: 1, sections: getCartSectionIds().join(',') })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          panelAdd.disabled = false;
          panelAdd.textContent = MINI_ADD_BUTTON_TEXT;
          if (data.status) return;
          if (panelConfirm) panelConfirm.hidden = false;
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            dispatchCartUpdate(cart, data.sections, 'fcp-upsell-add');
          });
          setTimeout(function () {
            if (panelConfirm) panelConfirm.hidden = true;
            closeUpsellPanel();
          }, 1600);
        })
        .catch(function () {
          panelAdd.disabled = false;
          panelAdd.textContent = MINI_ADD_BUTTON_TEXT;
        });
      });
    }
  }

  function populateUpsellPanel(data, imgSrc, productTitle) {
    if (!panel) return;
    currentMiniData = data;
    if (panelImage) { panelImage.src = imgSrc || ''; panelImage.alt = productTitle || ''; }
    if (panelSelect) {
      panelSelect.innerHTML = data.items.map(function (item) {
        return '<option value="' + item.id + '">' + item.label + ' — ' + money(item.price) + '</option>';
      }).join('');
      currentMiniVariantId = data.items.length ? data.items[0].id : null;
    }
    if (panelConfirm) panelConfirm.hidden = true;
    if (panelAdd) { panelAdd.disabled = false; panelAdd.textContent = MINI_ADD_BUTTON_TEXT; }
  }

  function getFcpChromeEls() {
    if (!modalContent) return [];
    var qty = modalContent.querySelector('.fcp-qv__qty-wrap');
    var atc = modalContent.querySelector('#fcp-atc');
    var link = modalContent.querySelector('.fcp-qv__full-link');
    return [qty, atc, link].filter(Boolean);
  }

  function setFcpChromeCollapsed(collapsed) {
    getFcpChromeEls().forEach(function (el) {
      el.classList.add('fcp-chrome');
      el.classList.toggle('fcp-chrome--collapsed', collapsed);
      if (collapsed) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });
  }

  function openUpsellPanel() {
    if (!panel || !modalBox) return;
    setFcpChromeCollapsed(true);
    modalBox.classList.add('has-upsell-open');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    var toggle = document.getElementById('fcp-mini-toggle');
    if (toggle) toggle.checked = true;
    setTimeout(function () {
      panel.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, CHROME_TRANSITION_MS);
  }

  function closeUpsellPanel() {
    if (!panel || !modalBox) return;
    panel.classList.remove('is-open');
    modalBox.classList.remove('has-upsell-open');
    var toggle = document.getElementById('fcp-mini-toggle');
    if (toggle) toggle.checked = false;
    setFcpChromeCollapsed(false);
  }

  function init() {
    setup();

    var tabs   = Array.from(document.querySelectorAll('.fcp-tab'));
    var panels = Array.from(document.querySelectorAll('.fcp-panel'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        // Tabs without a data-handle aren't part of this AJAX tab/panel
        // widget (e.g. sections/political-subnav.liquid reuses the
        // .fcp-tab class purely for shared styling, but is real <a href>
        // navigation between separate collection pages) — let those
        // navigate normally instead of being silently blocked below.
        var h = tab.dataset.handle;
        if (!h) return;
        e.preventDefault(); e.stopPropagation();
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t.dataset.handle === h);
          t.setAttribute('aria-selected', t.dataset.handle === h ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.handle === h); });
      });
    });

    window.addEventListener('click', function (e) {
      var el = e.target;
      while (el && el !== document.body) {
        if (el.classList && el.classList.contains('fcp-card') && el.dataset.productHandle) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.fcpOpen(el.dataset.productHandle, el.dataset.collectionHandle, el.dataset.collectionTitle, el.dataset.discoveryHtml);
          return;
        }
        if (hasGalleryImageClass(el)) {
          var galleryHandle = getHandleFromHref(el.getAttribute('href'));
          if (galleryHandle) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.fcpOpen(galleryHandle, el.dataset.collectionHandle, el.dataset.collectionTitle, el.dataset.discoveryHtml);
            return;
          }
        }
        if (el.classList && el.classList.contains('catalog-menu__card')) {
          var catalogMenuHandle = getHandleFromHref(el.getAttribute('href'));
          if (catalogMenuHandle) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.fcpOpen(catalogMenuHandle, el.dataset.collectionHandle, el.dataset.collectionTitle, el.dataset.discoveryHtml);
            return;
          }
        }
        if (el.classList && el.classList.contains('product-card__link')) {
          var handle = getHandleFromHref(el.getAttribute('href'));
          if (handle) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.fcpOpen(handle, el.dataset.collectionHandle, el.dataset.collectionTitle, el.dataset.discoveryHtml);
            return;
          }
        }
        if (el.tagName === 'PRODUCT-CARD') {
          var cardLink = el.querySelector('a.product-card__link');
          var cardHandle = cardLink ? getHandleFromHref(cardLink.getAttribute('href')) : null;
          if (cardHandle) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.fcpOpen(cardHandle, cardLink.dataset.collectionHandle, cardLink.dataset.collectionTitle, cardLink.dataset.discoveryHtml);
            return;
          }
        }
        el = el.parentElement;
      }
    }, true);
  }

  function renderModal(product, collectionHandle, collectionTitle, discoveryHtml) {
    closeUpsellPanel();

    var images   = product.images   || [];
    var variants = product.variants || [];
    var options  = product.options  || [];

    var miniData = getMiniPackData(product);
    var mainVariants = miniData
      ? variants.filter(function (v) {
          return miniData.indices.every(function (idx) {
            return !v.options[idx] || MINI_NONE_VALUES.indexOf(v.options[idx]) !== -1;
          });
        })
      : variants;
    if (!mainVariants.length) mainVariants = variants;

    var materialIdx = findMaterialOptionIndex(options, miniData ? miniData.indices : []);

    var current = mainVariants[0] || {};
    if (materialIdx !== -1) {
      var preferred = mainVariants.filter(function (v) {
        var val = v.options[materialIdx];
        return val && val.indexOf(MAGNET_PREFIX) !== 0 && val !== HIDDEN_PLACEHOLDER_VALUE;
      })[0];
      if (preferred) current = preferred;
    }

    var mainSrc    = images.length ? imgUrl(images[0], 900) : '';
    var miniImg    = images.length ? imgUrl(images[0], 300) : mainSrc;
    var thumbsHtml = images.slice(0, 8).map(function (img, i) {
      return '<div class="fcp-qv__thumb' + (i === 0 ? ' is-active' : '') +
        '" data-src="' + imgUrl(img, 900) + '">' +
        '<img src="' + imgUrl(img, 160) + '" alt="" loading="lazy"></div>';
    }).join('');

    var singleDefault = options.length === 1 && options[0].name === 'Title' && options[0].values[0] === 'Default Title';

    var stickerValues = [];
    var magnetValues  = [];
    var hasToggle = false;

    if (materialIdx !== -1) {
      var rawVals = options[materialIdx].values.slice();
      if (miniData) rawVals = rawVals.filter(function (v) { return v !== HIDDEN_PLACEHOLDER_VALUE; });
      stickerValues = rawVals.filter(function (v) { return v.indexOf(MAGNET_PREFIX) !== 0; });
      magnetValues  = rawVals.filter(function (v) { return v.indexOf(MAGNET_PREFIX) === 0; })
                             .map(function (v) { return v.slice(MAGNET_PREFIX.length); });
      hasToggle = stickerValues.length > 0 && magnetValues.length > 0;
    }

    var toggleSizeHtml = '';
    if (hasToggle) {
      toggleSizeHtml =
        '<div class="fcp-qv__option"><div class="fcp-qv__label">Type</div>' +
        '<select class="fcp-qv__select" id="fcp-type-select">' +
          '<option value="Sticker">Sticker</option>' +
          '<option value="Magnet">Magnet</option>' +
        '</select></div>' +
        '<div class="fcp-qv__option" id="fcp-size-wrap"><div class="fcp-qv__label">Size</div>' +
        '<select class="fcp-qv__select" id="fcp-size-select"></select></div>';
    } else if (materialIdx !== -1) {
      var vals2 = options[materialIdx].values;
      if (miniData) vals2 = vals2.filter(function (v) { return v !== HIDDEN_PLACEHOLDER_VALUE; });
      if (vals2.length) {
        toggleSizeHtml = '<div class="fcp-qv__option"><div class="fcp-qv__label">' + options[materialIdx].name + '</div>' +
          '<select class="fcp-qv__select" data-opt-idx="' + materialIdx + '">' +
          vals2.map(function (v) { return '<option value="' + v + '">' + v + '</option>'; }).join('') +
          '</select></div>';
      }
    }

    var optionsHtml = singleDefault ? '' : options.map(function (opt, i) {
      if (miniData && miniData.indices.indexOf(i) !== -1) return '';
      if (i === materialIdx) return '';
      var vals = opt.values;
      if (miniData) { vals = vals.filter(function (v) { return v !== HIDDEN_PLACEHOLDER_VALUE; }); }
      if (!vals.length) return '';
      return '<div class="fcp-qv__option"><div class="fcp-qv__label">' + opt.name + '</div>' +
        '<select class="fcp-qv__select" data-opt-idx="' + i + '">' +
        vals.map(function (v) { return '<option value="' + v + '">' + v + '</option>'; }).join('') +
        '</select></div>';
    }).join('');

    var miniToggleHtml = miniData
      ? '<label class="fcp-qv__mini-toggle" for="fcp-mini-toggle"><input type="checkbox" id="fcp-mini-toggle"> Add matching 1&quot; mini stickers?</label>'
      : '';

    function priceHtml(v) {
      var out = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        out += '<s style="opacity:.45;margin-right:.4rem;font-weight:400">' + money(v.compare_at_price) + '</s>';
      }
      return out + money(v.price);
    }

    /* Cross-collection discovery block ("Also found in" + "Try our other
       collections" + CLOSE link), pre-rendered server-side per card and
       carried through as a base64 data attribute — see decodeDiscoveryHtml
       above for why. Falls back to the original single Back-to-collection
       (or full-product-page) link when no discoveryHtml was provided, e.g.
       a trigger surface that hasn't been wired with the attribute yet.
       Wrapped in .fcp-qv__full-link (repurposed as a generic wrapper class,
       not literally "one link" anymore) so it's still picked up unchanged
       by getFcpChromeEls()'s existing selector for the mini-sticker
       upsell-panel collapse animation. */
    var decodedDiscovery = decodeDiscoveryHtml(discoveryHtml);
    var backLinkHtml = decodedDiscovery
      ? '<div class="fcp-qv__full-link fcp-qv__discovery-wrap">' + decodedDiscovery + '</div>'
      : ((collectionHandle && collectionTitle)
        ? '<a href="/collections/' + collectionHandle + '" class="fcp-qv__full-link">Back to \'' + escapeHtml(collectionTitle) + '\' &rarr;</a>'
        : '<a href="/products/' + product.handle + '" class="fcp-qv__full-link">Back to full product page &rarr;</a>');

    modalContent.innerHTML =
      '<div class="fcp-qv">' +
        '<div class="fcp-qv__images">' +
          '<div class="fcp-qv__main-img">' +
            (mainSrc
              ? '<img id="fcp-main-img" src="' + mainSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '">'
              : '<div class="fcp-qv__no-img">No image</div>') +
          '</div>' +
          (thumbsHtml ? '<div class="fcp-qv__thumbs">' + thumbsHtml + '</div>' : '') +
        '</div>' +
        '<div class="fcp-qv__details">' +
          '<h2 class="fcp-qv__title">' + product.title + '</h2>' +
          '<p class="fcp-qv__price" id="fcp-price">' + priceHtml(current) + '</p>' +
          toggleSizeHtml +
          optionsHtml +
          '<div class="fcp-qv__qty-wrap"><div class="fcp-qv__label">Quantity</div>' +
            '<div class="fcp-qv__qty-row">' +
              '<button class="fcp-qv__qty-btn" id="fcp-qty-down" type="button">&minus;</button>' +
              '<input class="fcp-qv__qty-input" id="fcp-qty" type="number" min="1" value="1">' +
              '<button class="fcp-qv__qty-btn" id="fcp-qty-up" type="button">+</button>' +
            '</div></div>' +
          miniToggleHtml +
          '<button class="fcp-qv__atc" id="fcp-atc" type="button"' + (!current.available ? ' disabled' : '') + '>' +
            (current.available ? 'Add to Cart' : 'Sold Out') +
          '</button>' +
          '<div class="fcp-qv__msg" id="fcp-msg"></div>' +
          backLinkHtml +
        '</div>' +
      '</div>';

    var selectedOpts = current.options ? current.options.slice() : [];
    var variantId    = current.id;

    function findVariant() {
      var pool = mainVariants.length ? mainVariants : variants;
      return pool.find(function (v) {
        return v.options.every(function (o, i) {
          if (miniData && miniData.indices.indexOf(i) !== -1) return true;
          return o === selectedOpts[i];
        });
      }) || current;
    }

    function setVariant(v) {
      if (!v) return;
      variantId = v.id;
      var el = document.getElementById('fcp-price');
      if (el) el.innerHTML = priceHtml(v);
      var btn = document.getElementById('fcp-atc');
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      var viSrc = v.featured_image ? getSrc(v.featured_image) : '';
      if (viSrc) {
        var mi = document.getElementById('fcp-main-img');
        if (mi) mi.src = imgUrl(viSrc, 900);
      }
    }

    if (hasToggle) {
      var typeSelect = document.getElementById('fcp-type-select');
      var sizeSelect = document.getElementById('fcp-size-select');
      var sizeWrap   = document.getElementById('fcp-size-wrap');

      function listFor(type) { return type === 'Magnet' ? magnetValues : stickerValues; }

      function populateSizeOptions(type, preferredSize) {
        var list = listFor(type);
        sizeSelect.innerHTML = list.map(function (v) { return '<option value="' + v + '">' + v + '</option>'; }).join('');
        if (preferredSize && list.indexOf(preferredSize) !== -1) sizeSelect.value = preferredSize;
        if (sizeWrap) sizeWrap.style.display = list.length > 1 ? '' : 'none';
      }

      function applyTypeSize() {
        var type = typeSelect.value;
        var size = sizeSelect.value;
        selectedOpts[materialIdx] = (type === 'Magnet') ? (MAGNET_PREFIX + size) : size;
        setVariant(findVariant());
      }

      var initialRaw  = selectedOpts[materialIdx];
      var initialType = (typeof initialRaw === 'string' && initialRaw.indexOf(MAGNET_PREFIX) === 0) ? 'Magnet' : 'Sticker';
      var initialSize = initialType === 'Magnet' ? initialRaw.slice(MAGNET_PREFIX.length) : initialRaw;
      typeSelect.value = initialType;
      populateSizeOptions(initialType, initialSize);

      typeSelect.addEventListener('change', function () {
        var prevSize = sizeSelect.value;
        populateSizeOptions(typeSelect.value, prevSize);
        applyTypeSize();
      });
      sizeSelect.addEventListener('change', applyTypeSize);
    }

    modalContent.querySelectorAll('.fcp-qv__select[data-opt-idx]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        selectedOpts[parseInt(sel.dataset.optIdx)] = sel.value;
        setVariant(findVariant());
      });
    });

    modalContent.querySelectorAll('.fcp-qv__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        modalContent.querySelectorAll('.fcp-qv__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var mi = document.getElementById('fcp-main-img');
        if (mi) mi.src = thumb.dataset.src;
      });
    });

    var qtyInput = document.getElementById('fcp-qty');
    document.getElementById('fcp-qty-down').addEventListener('click', function () {
      if (parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
    });
    document.getElementById('fcp-qty-up').addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });

    var miniToggle = document.getElementById('fcp-mini-toggle');
    if (miniToggle) {
      miniToggle.addEventListener('change', function () {
        if (miniToggle.checked) {
          if (miniData) { populateUpsellPanel(miniData, miniImg, product.title); openUpsellPanel(); }
        } else {
          closeUpsellPanel();
        }
      });
    }

    document.getElementById('fcp-atc').addEventListener('click', function () {
      var btn = this, msgEl = document.getElementById('fcp-msg'), qty = parseInt(qtyInput.value) || 1;
      btn.disabled = true; btn.textContent = 'Adding…';
      msgEl.className = 'fcp-qv__msg'; msgEl.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, sections: getCartSectionIds().join(',') })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          msgEl.textContent = data.description || 'Could not add to cart.';
          msgEl.className = 'fcp-qv__msg error';
          btn.disabled = false; btn.textContent = 'Add to Cart';
        } else {
          msgEl.textContent = '✓ Added to cart!';
          msgEl.className = 'fcp-qv__msg success';
          btn.disabled = false; btn.textContent = 'Add to Cart';
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            dispatchCartUpdate(cart, data.sections, 'fcp-atc');
          });
          if (miniData) {
            populateUpsellPanel(miniData, miniImg, product.title);
            openUpsellPanel();
          }
        }
      })
      .catch(function () {
        msgEl.textContent = 'Something went wrong. Please try again.';
        msgEl.className = 'fcp-qv__msg error';
        btn.disabled = false; btn.textContent = 'Add to Cart';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
